/**
 * @file: Health.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 健康证管理
 */
import request from '@/utils/request'

/**
 * 获取在岗人员个数（食堂级）（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function healthDeptObjobStatisticsGet(data) {
  return request({
    type: 'biz',
    url: 'health/dept/objob/statistics/get',
    method: 'post',
    data
  })
}

/**
 * 根据食堂ID获取健康证过期人员列表(liurl)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function healthExpiryDeptListGet(data) {
  return request({
    type: 'biz',
    url: 'health/expiry/dept/list/get',
    method: 'post',
    data
  })
}

/**
 * 商汤事件推送（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function healthSenseEventpushInsert(data) {
  return request({
    type: 'biz',
    url: 'health/sense/eventpush/insert',
    method: 'post',
    data
  })
}

/**
 * NVR人员入侵（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function healthSenseNvruser(data) {
  return request({
    type: 'biz',
    url: 'health/sense/nvruser',
    method: 'post',
    data
  })
}

/**
 * 移动端-获取今日健康证统计(cme)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function healthStatusCountGet(data) {
  return request({
    type: 'biz',
    url: 'health/status/count/get',
    method: 'post',
    data
  })
}

/**
 * 业务数据中心-大数据分析-体温监测列表-导出全部数据(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function healthTemperatureBaseStatisticExport(data) {
  return request({
    type: 'biz',
    url: 'health/temperature/base/statistic/export',
    method: 'post',
    data
  })
}

/**
 * 业务数据中心-大数据分析-体温监测统计(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function healthTemperatureBaseStatisticGet(data) {
  return request({
    type: 'biz',
    url: 'health/temperature/base/statistic/get',
    method: 'post',
    data
  })
}

/**
 * 业务数据中心-大数据分析-体温监测列表(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function healthTemperatureBaseStatisticList(data) {
  return request({
    type: 'biz',
    url: 'health/temperature/base/statistic/list',
    method: 'post',
    data
  })
}

/**
 * 业务数据中心-大数据分析-体温监测列表-导出选择数据(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function healthTemperatureBaseStatisticOptionExport(data) {
  return request({
    type: 'biz',
    url: 'health/temperature/base/statistic/option/export',
    method: 'post',
    data
  })
}

/**
 * 根据食堂ID获取今日体温异常人员列表信息(liurl)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function healthTemperatureExceptionTodayGet(data) {
  return request({
    type: 'biz',
    url: 'health/temperature/exception/today/get',
    method: 'post',
    data
  })
}

/**
 * 移动端-获取今日体温异常人数(cme)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function healthTemperatureExceptionUserCountGet(data) {
  return request({
    type: 'biz',
    url: 'health/temperature/exception/user/count/get',
    method: 'post',
    data
  })
}

/**
 * 移动端-数据统计-获取近 7日体温异常人数趋势(cme)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function healthTemperatureSevenDayExceptionGet(data) {
  return request({
    type: 'biz',
    url: 'health/temperature/seven/day/exception/get',
    method: 'post',
    data
  })
}

/**
 * 手动执行定时任务（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function healthTimingTask(data) {
  return request({
    type: 'biz',
    url: 'health/timing/task',
    method: 'post',
    data
  })
}

/**
 * 大屏显示-食堂-点击晨检设备显示体温检测记录（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcHealthDeptDeviceTemperature(data) {
  return request({
    type: 'biz',
    url: 'pc/health/dept/device/temperature',
    method: 'post',
    data
  })
}

/**
 * 获取健康证过期人员列表
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcHealthExpiryListGet(data) {
  return request({
    type: 'biz',
    url: 'pc/health/expiry/list/get',
    method: 'post',
    data
  })
}

/**
 * 报表中心-各食堂人员分布情况统计（导出Excel）（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcHealthExportPeopleCountGet(data) {
  return request({
    type: 'biz',
    url: 'pc/health/export/people/count/get',
    method: 'post',
    data
  })
}

/**
 * 添加健康证信息(ndj)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcHealthInfoAdd(data) {
  return request({
    type: 'biz',
    url: 'pc/health/info/add',
    method: 'post',
    data
  })
}

/**
 * 健康证删除(ndj)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcHealthInfoDelete(data) {
  return request({
    type: 'biz',
    url: 'pc/health/info/delete',
    method: 'post',
    data
  })
}

/**
 * 获取健康证信息(ndj)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcHealthInfoGet(data) {
  return request({
    type: 'biz',
    url: 'pc/health/info/get',
    method: 'post',
    data
  })
}

/**
 * 修改健康证信息(ndj)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcHealthInfoUpdate(data) {
  return request({
    type: 'biz',
    url: 'pc/health/info/update',
    method: 'post',
    data
  })
}

/**
 * 分页获取健康证列表(ndj)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcHealthListGet(data) {
  return request({
    type: 'biz',
    url: 'pc/health/list/get',
    method: 'post',
    data
  })
}

/**
 * 各食堂人员分布情况统计
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcHealthPeopleCountGet(data) {
  return request({
    type: 'biz',
    url: 'pc/health/people/count/get',
    method: 'post',
    data
  })
}

/**
 * 报表中心-各食堂人员分布情况统计(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcHealthReportPeopleCountGet(data) {
  return request({
    type: 'biz',
    url: 'pc/health/report/people/count/get',
    method: 'post',
    data
  })
}

/**
 * 体温测量明细分页查询（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcHealthTemperaturePageGet(data) {
  return request({
    type: 'biz',
    url: 'pc/health/temperature/page/get',
    method: 'post',
    data
  })
}

/**
 * 大屏显示-整体视图-体温异常人员（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcHealthWholeviewExceptionTemperature(data) {
  return request({
    type: 'biz',
    url: 'pc/health/wholeview/exception/temperature',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/Health.js